<template>
  <div
    class="container-sm"
    style="background: #ffffff; width:90%; max-width:1000px; margin:0 auto;"
  >
    <div v-if="!loggedIn">
      <div
        class="col-auto text-center w-100"
        v-if="settings && settings.appTitle"
      >
        <div class="md" v-html="markedHtml(settings.appTitle)"></div>
      </div>
      <div class="text-center" v-else>
        <h1>TiBTiX Servicekleber</h1>
      </div>
    </div>

    <div class="" ref="loginComponent" v-if="currentPage === displayPage.LOGIN">
      <login
        @setloggedin="setLoggedIn"
        @cancel="show(displayPage.HOME)"
        @error="error"
        :tp="tp"
        :showDomainAccountList="isEmptyString(currentTibTag)"
      ></login>
    </div>

    <div v-if="currentPage === displayPage.NEW_QR_CODE">
      <login
        @setloggedin="setLoggedIn"
        @cancel="show(displayPage.HOME)"
        @error="error"
        :tp="tp"
        :title="'Neuen Servicekleber erfassen'"
        :description="tp.newQrCodeDescription"
        :showDomainAccountList="false"
      ></login>
    </div>

    <div class="" v-if="currentPage === displayPage.ERROR">
      <div class="alert alert-warning alert-dismissible fade show">
        <h4 class="alert-heading"><i class="fa fa-warning"></i>Fehler!</h4>
        <p>{{ errorMessage }}</p>
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          @click="back()"
        >
          &times;
        </button>
      </div>
    </div>

    <div class="row mx-auto" v-if="currentPage === displayPage.CODE">
      <div class="col-md-12 text-center px-3 py-3">
        <numPad @code="code"></numPad>
      </div>
    </div>

    <div
      class="row mx-auto"
      v-if="
        publicDomainAccountProperties &&
          (currentPage === displayPage.HOME ||
            currentPage === displayPage.NEW_QR_CODE ||
            currentPage === displayPage.ONBOARD
            )
      "
    >
      <div class="col-auto text-center w-100">
        <a
          :href="
            publicDomainAccountProperties &&
              publicDomainAccountProperties.homepage
          "
        >
          <img
            class="img-fluid"
            :src="
              '/tt/api/image/' +
                publicDomainAccountProperties.accountName +
                '/' +
                publicDomainAccountProperties.hashhashDomain +
                '/account'
            "
            style="width: 200px; height:auto;"
          />
        </a>
      </div>
    </div>

    <div class="row justify-content-around mt-3">
      <div
        class="text-center mt-3 w-75"
        v-if="currentPage === displayPage.ADDRESS_LIST && loggedIn"
      >
        <button
          type="button"
          class="btn btn-primary w-100"
          @click="tibtixAdmin()"
        >
          TiBTiX Admin
        </button>
      </div>
      <div
        class="text-center mt-3 w-75"
        v-if="currentPage === displayPage.HOME && currentServicekleber && currentServicekleber.tib.attributesMap.payAccount && !loggedIn"
      >
        <button
          type="button"
          class="btn btn-primary w-100"
          @click="pay()"
        >
          <i class="fas fa-credit-card"></i> Bezahlen
        </button>
      </div>

      <div
        class="text-center mt-3 w-75"
        v-if="(currentPage === displayPage.HOME || currentPage == displayPage.ADDRESS) && !loggedIn"
      >
        <button
          type="button"
          class="btn btn-primary w-100"
          @click="show(displayPage.CODE)"
        >
          <i class="fas fa-th"></i> {{ tp.enterCode }}
        </button>
      </div>

      <div
        class="text-center mt-3 w-75"
        v-if="currentPage === displayPage.HOME && currentServicekleber && currentServicekleber.tib.attributesMap.payAccount && !loggedIn"
      >
        <button
          type="button"
          class="btn btn-default w-100"
          @click="show(displayPage.ONBOARD)"
        >
          <i class="fas fa-user"></i> Registrieren...
        </button>
      </div>

      <button
        type="button"
        class="btn btn-default w-100"
        @click="showOnlyPayButton = !showOnlyPayButton"
        v-if="(currentPage === displayPage.HOME || currentPage === displayPage.LOGIN) && currentServicekleber && currentServicekleber.tib.attributesMap.payAccount && showOnlyPayButton"
      >
        Mehr...
      </button>
      <div
        class="text-center mt-3 w-75"
        v-if="
          currentServicekleber &&
          (currentPage == null || currentPage === displayPage.HOME) &&
          loggedIn
        "
      >
        <button
          type="button"
          class="btn btn-primary w-100"
          @click="show(displayPage.ADDRESS)"
        >
          <i class="fas fa-edit"></i> {{ tp.edit }}
        </button>
      </div>

      <div class="w-100 row justify-content-around"
           v-if="currentPage != displayPage.HOME || !(currentServicekleber && currentServicekleber.tib.attributesMap.payAccount) || !showOnlyPayButton">
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.HOME && !loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.FAULT_REPORT)"
          >
            <i class="fas fa-exclamation-circle"></i> Störungsmeldung erfassen
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="
          (currentPage === displayPage.HOME ||
            currentPage === displayPage.ADDRESS_LIST || currentPage === displayPage.ADDRESS) &&
            loggedIn
        "
        >
          <button
            ref="logoutButton"
            type="button"
            class="btn btn-primary w-100"
            data-dismiss="modal"
            @click="logout()"
          >
            <i class="fas fa-sign-out-alt"></i> {{ tp.logout }}
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="
          currentServicekleber &&
            currentPage != displayPage.HOME &&
            currentPage != displayPage.FAULT_REPORT &&
            currentPage != displayPage.TIME_TRACKING &&
            !loggedIn
        "
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.HOME)"
          >
            <i class="fas fa-home"></i> Übersicht
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.ADDRESS_LIST && loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="showDomainJournal()"
          >
            <i class="fas fa-clock"></i> Alle Journale
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.ADDRESS_LIST && loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.SERVICEKLEBER_LIST)"
          >
            Alle Servicekleber
          </button>
        </div>

        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.HOME && !loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.TIBS)"
          >
            <i class="fas fa-file"></i> Mehr Informationen
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.HOME && !loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.TIB_JOURNAL)"
          >
            <i class="fas fa-clock"></i> Journal
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.HOME && !loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.LOGIN)"
          >
            <i class="fas fa-sign-in-alt"></i> Login
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="
          currentPage === displayPage.ADDRESS_LIST ||
            currentPage === displayPage.HOME ||
            currentPage === displayPage.LOGIN ||
            currentPage === displayPage.TIME_TRACKING
        "
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.SCAN)"
          >
            <i class="fas fa-qrcode"></i> QR Code Scannen
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.SCAN"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.HOME)"
          >
            <i class="fas fa-arrow-left"></i>&nbsp;Zurück
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.ADDRESS_LIST && loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.ADMIN_TIMETRACKING)"
          >
            Zeiterfassung Admin
          </button>
        </div>
        <div
          class="text-center mt-3 w-75"
          v-if="currentPage === displayPage.HOME && !loggedIn"
        >
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="show(displayPage.TIME_TRACKING)"
          >
            <i class="fas fa-time"></i>&nbsp;Zeiterfassung
          </button>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-around mt-3"
      v-if="
        currentServicekleber &&
          currentServicekleber.tib &&
          currentServicekleber.tib.name &&
          currentPage === displayPage.HOME
      "
    >
      <servicekleberView
        ref="servicekleberView"
        :servicekleberProperty="currentServicekleber"
        :newTibTagProperty="newTibTag"
        :tp="tp"
      ></servicekleberView>
    </div>
    <div
      class="row justify-content-around mt-3"
      v-if="cashInActive && currentPage === displayPage.CODE">
      <cashIn :tibTag="currentTibTag"></cashIn>
    </div>
    <journalOnboardComponent
      v-if="currentPage === displayPage.ONBOARD"
      @savejournalentry="addJournalEntry"
      @cancel="show(displayPage.HOME)"
      ref="journalOnboardComponent"
      :tibModelProperty="currentServicekleber.tib"
      :loggedIn="loggedIn"
      :tp="tp"
    ></journalOnboardComponent>
    <div
      class="row w-100 mt-3"
      v-if="
        currentServicekleber &&
          currentServicekleber.tib &&
          currentServicekleber.tib.name &&
          currentPage === displayPage.TIB_JOURNAL
      "
    >
      <journalComponent
        @savejournalentry="saveJournalEntry"
        ref="journalComponent"
        :tibModelProperty="currentServicekleber.tib"
        :loggedIn="loggedIn"
        :tp="tp"
      ></journalComponent>
    </div>

    <div
      class="row justify-content-around mt-3"
      v-if="
        currentServicekleber &&
          currentServicekleber.tib &&
          currentServicekleber.tib.name &&
          currentPage === displayPage.TIBS
      "
    >
      <servicekleberTibsView
        :servicekleberProperty="currentServicekleber"
        :tp="tp"
      ></servicekleberTibsView>
    </div>

    <div
      class="row justify-content-around mt-3"
      v-if="
        currentServicekleber &&
          currentServicekleber.tib &&
          currentPage === displayPage.FAULT_REPORT
      "
    >
      <faultReport
        :servicekleberProperty="currentServicekleber"
        :faultReportTitleProperty="getFaultReportTitle()"
        @savejournalentry="saveJournalEntry"
        @cancel="show(displayPage.HOME)"
      ></faultReport>
    </div>

    <div class="mt-3" ref="contentComponent">
      <div
        ref="addressList"
        class="w-100 mx-auto my-3"
        v-if="currentPage === displayPage.ADDRESS_LIST"
      >
        <h1>Alle Adressen</h1>
        <div class="md mt-3 wkMessageInline" v-if="newTibTag">
          <p>
            Bitte wählen Sie eine Adresse, wo ein neuer Kleber erfasst werden
            soll oder einen bestehen Servicekleber, dem ein neuer QR Code
            zugeordnet werden soll
          </p>
        </div>
        <div v-for="(address, index) in addresses" :key="index">
          <addressItem
            :addressProperty="address"
            @selectaddress="showAddress"
            :newTibTagProperty="newTibTag"
            :tp="tp"
          >
          </addressItem>
        </div>
        <button
          @click="createAddress()"
          class="btn btn-outline-dark btn-block mt-3 mb-3"
        >
          <i class="fas fa-plus"></i> {{ tp.createNewAddress }}
        </button>
      </div>
      <div
        ref="addressList"
        class="w-100 mx-auto my-3"
        v-if="currentPage === displayPage.SERVICEKLEBER_LIST"
      >
        <div class="text-center mt-3 w-100">
          <button @click="showAddressList()" class="btn btn-primary w-75">
            <i class="fas fa-arrow-left"></i>&nbsp;Zurück
          </button>
        </div>
        <div class="text-center mt-3 w-100">
          <button @click="updateData()" class="btn btn-primary w-75">
            <i class="fas fa-arrows-rotate"></i> Alle neu laden
          </button>
        </div>
        <h1 class="mt-3">Alle Servicekleber</h1>
        <input type="text" v-model="searchText" placeholder="Suchen"/>

        <h1>Anzahl = {{allServicekleber.length}}</h1>
        <div v-for="(sk, index) in allServicekleber">
          <h5>{{index}}) {{sk.tib.name == sk.tib.name ? sk.tib.name : sk.tib.name + " " + sk.data.extRef}}</h5>
        </div>


        <div v-for="(address, index) in addresses" :key="index">
          <h2 @click="showAddress(address)">{{ address.tib.name }}</h2>
          <div
            class="md wkMessageInline"
            v-if="address.data.popupMessage"
            v-html="markedHtml(address.data.popupMessage)"
          ></div>
          <div class="d-flex align-content-start flex-wrap containerBorder">
            <div
              v-for="(servicekleber, index) in address.servicekleber"
              :key="index"
            >
              <div
                v-if="filter(servicekleber)"
                class="containerBorder text-center"
                @click="
                  showServicekleber(servicekleber);
                  show(displayPage.ADDRESS);
                "
              >
                <h5>
                  {{
                    servicekleber &&
                    servicekleber.tib &&
                    (servicekleber.tib.name == servicekleber.data.extRef
                      ? servicekleber.tib.name
                      : servicekleber.tib.name + " " + servicekleber.data.extRef)
                  }}
                </h5>
                <p>{{ servicekleber.tib.attributesMap.payAccount }}</p>
                <img
                  class="img-responsive"
                  :src="'/tt/tib/' + servicekleber.tib.tag + '/qr.png?size=100'"
                />
                <div
                  class="md mt-3 wkMessageInline"
                  v-if="servicekleber.data.popupMessage"
                  v-html="markedHtml(servicekleber.data.popupMessage)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-100 rounded"
        v-if="currentAddress && currentPage === displayPage.ADDRESS"
      >
        <addressDetails
          ref="addressDetails"
          :addressProperty="currentAddress"
          :currentServicekleberProperty="currentServicekleber"
          @showaddresslist="showAddressList"
          @selectaddress="showAddress"
          @selectservicekleber="showServicekleber"
          @createservicekleber="createServicekleber"
          @savejournalentry="saveJournalEntry"
          @tibTagChanged="tibTagChanged"
          @error="error"
          :newTibTagProperty="newTibTag"
          :tp="tp"
        >
        </addressDetails>
      </div>

      <div
        class="w-100 mt-3 text-center"
        v-if="currentAddress && currentPage === displayPage.ADDRESS"
      >
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ tp.file }}</span>
          </div>
          <div class="custom-file">
            <input
              type="file"
              size="10"
              class="custom-file-input"
              id="fileInput"
              ref="fileInput"
              v-on:change="handleFileUpload()"
            />
            <label class="custom-file-label" for="fileInput" ref="fileLabel">
              {{ fileName }}</label
            >
          </div>
          <div class="input-group-append" v-if="fileName">
            <button
              class="btn btn-outline-dark"
              type="button"
              v-on:click="uploadFile($event)"
            >
              {{ tp.upload }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="row mx-auto"
        v-if="currentPage === displayPage.DOMAIN_JOURNAL"
      >
        <div class="text-center mt-3 w-100">
          <button @click="showAddressList()" class="btn btn-primary w-75">
            <i class="fas fa-arrow-left"></i>&nbsp;Zurück
          </button>
        </div>
        <h1 class="mt-3">Alle Journale</h1>
        <journalComponent
          @savejournalentry="saveJournalEntry"
          @cancel="show(displayPage.HOME)"
          :loggedIn="loggedIn"
          :journalEntriesProperty="domainJournalEntries"
          :tp="tp"
        ></journalComponent>
      </div>

      <div
        class="modal-dialog modal-xl"
        role="document"
        v-if="currentPage === displayPage.EDIT_JOURNAL_ENTRY"
      >
        <journalEntryComponent
          @savejournalentry="addJournalEntry"
          :loggedIn="false"
          @cancel="show(displayPage.HOME)"
          :journalEntryProperty="journalEntry"
          :tp="tp"
        ></journalEntryComponent>
      </div>

      <div class="row mx-auto" v-if="currentPage === displayPage.TIME_TRACKING">
        <div class="text-center mt-3 w-100">
          <button @click="show(displayPage.HOME)" class="btn btn-primary w-75">
            <i class="fas fa-arrow-left"></i>&nbsp;Zurück
          </button>
        </div>
        <timetracking
          :servicekleber="currentServicekleber"
          :settings="settings"
          :properties="properties"
          :tp="tp"
          @error="error"
        ></timetracking>
      </div>
    </div>

    <div class="wkMessage" v-if="isMessageVisible">
      <div
        class="md"
        v-html="markedHtml(currentServicekleber.data.popupMessage)"
      ></div>
      <div
        class="md"
        v-html="markedHtml(currentServicekleber.address.data.popupMessage)"
      ></div>
      <button
        type="button"
        class="btn btn-outline-dark"
        @click="showMessage(false)"
      >
        {{ tp.ok }}
      </button>
    </div>

    <div class="wkMessage" v-if="infoMessage">
      <div
        class="md"
        v-html="markedHtml(infoMessage)"
      ></div>
      <button
        type="button"
        class="btn btn-outline-dark"
        @click="cancelInfoMessage"
      >
        {{ tp.ok }}
      </button>
    </div>

    <div v-if="currentPage === displayPage.SCAN">
      <h1>QR Code erfassen</h1>
      <qrcode-stream @decode="onScan" @init="onInit"></qrcode-stream>
    </div>

    <div
      v-if="
        currentPage === displayPage.ADMIN_TIMETRACKING && properties != null
      "
    >
      <div class="text-center mt-3 w-100">
        <button @click="showAddressList()" class="btn btn-primary w-75">
          <i class="fas fa-arrow-left"></i>&nbsp;Zurück
        </button>
      </div>
      <adminTimetracking
        :settingsTib="settingsTib"
        :settings="settings"
        :propertiesTib="propertiesTib"
        :properties="properties"
        :templateTibs="templateTibs"
        @error="error"
      ></adminTimetracking>
    </div>
  </div>
</template>

<script>
import {
  displayPage,
  emptyJournalEntry,
  translation,
  TT_URL,
  lang,
  BASE_PATH,
  emptyAddress,
  emptyServicekleber
} from "@/common/constants";
import {
  getCookie,
  isEmptyString,
  setCookie,
  markedHtml
} from "@/common/utils";
import {
  createServicekleberFromTibModel
} from "@/common/servicekleberutils";
import servicekleberView from "@/components/ServiceKleberView.vue";
import numPad from "@/components/journal/NumPad.vue";
import login from "@/components/Login.vue";
import servicekleberTibsView from "@/components/ServiceKleberTibsView.vue";
import journalComponent from "@/components/journal/JournalComponent.vue";
import journalEntryComponent from "@/components/journal/JournalEntryComponent.vue";
import journalOnboardComponent from "@/components/journal/JournalOnboardComponent.vue";
import {QrcodeStream, QrcodeDropZone, QrcodeCapture} from "vue-qrcode-reader";
import faultReport from "@/components/FaultReport.vue";
import timetracking from "@/components/timetracking/TimeTracking.vue";
import addressDetails from "@/components/AddressDetails.vue";
import adminTimetracking from "@/components/timetracking/AdminTimeTracking.vue";
import addressItem from "@/components/AddressItem.vue";
import cashIn from "@/components/servicekleber/CashIn.vue";

// import { getAddressByExtRef } from "@/common/schoch"; loaded in external file as workaround.
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "ServicekleberApp",
  components: {
    servicekleberView,
    login,
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    numPad,
    faultReport,
    servicekleberTibsView,
    journalComponent,
    timetracking,
    addressDetails,
    journalEntryComponent,
    journalOnboardComponent,
    adminTimetracking,
    addressItem,
    cashIn
  },
  data: function () {
    return {
      tp: {},
      language: "DE",
      loggedIn: false,
      settings: null,
      settingsTib: null,
      properties: null,
      propertiesTib: null,
      publicDomainAccountProperties: null,
      currentPage: displayPage.HOME,
      currentDir: "/",
      currentTibTag: "{tag}",
      newTibTag: null,
      currentTibModel: {},
      currentAddress: null,
      currentServicekleber: null,
      messageVisible: false,
      nextAddressId: 1,
      dirs: [],
      tibs: [],
      templateTibs: [],
      addresses: [],
      allServicekleber: [],
      file: {},
      fileName: "",
      journalEntry: emptyJournalEntry,
      domainJournalEntries: null,
      errorMessage: "",
      infoMessage: null,
      navbar: "home",
      menuItems: [],
      searchText: "",
      extRefForNewServicekleber: "",
      displayPage: displayPage,
      markedHtml: markedHtml,
      isEmptyString: isEmptyString,
      cashInActive: false,
      showOnlyPayButton: false
    };
  },
  mounted() {
    this.updateData();
    this.observeBrowserUrl();
    this.showMessage(true);
    if (
      new URL(location.href).searchParams.get("currentPage") ==
      displayPage.NEW_QR_CODE
    ) {
      this.newTibTag = this.currentTibTag;
      console.info("newTibTag: " + this.newTibTag);
    }
    if (isEmptyString(this.currentTibTag)) {
      this.show(displayPage.LOGIN);
    }
  },
  beforeMount() {
    this.updateLoginStatus();
    this.updateTranslations();
    this.currentTibTag = new URL(location.href).searchParams.get("tag");
  },
  watch: {},
  methods: {
    updateData() {
      this.updateDomainAccountProperties();
      this.listAllTibs();
    },
    listAllTibs() {
      console.info("listAllTibs()");
      console.info("this.loggedIn=" + this.loggedIn);

      let self = this;

      if (this.loggedIn) {
        axios
          .get(TT_URL + "/api/client/getAllTibsByApp" + BASE_PATH)
          .then(response => this.initTibs(response.data))
          .catch(function (error) {
            if (error && error.response) {
              if (error.response.status && error.response.status === 401) {
                self.loggedIn = false;
              }
            }
          });
      } else if (
        !isEmptyString(this.currentTibTag) &&
        this.currentTibTag != "{tag}"
      ) {
        axios
          .get(TT_URL + "/api/client/getAllTibsByAppTib/" + this.currentTibTag + "?path=..")
          .then(response => this.initTibs(response.data))
          .catch(function (error) {
            if (error && error.response) {
              if (error.response.status && error.response.status === 401) {
                self.loggedIn = false;
              }
            }
          });
      }
    },
    updateDomainAccountProperties() {
      let self = this;
      var tag = isEmptyString(this.currentTibTag)
        ? "no_tag"
        : this.currentTibTag;
      axios
        .get(TT_URL + "/api/client/getDomainAccountProperties/" + tag)
        .then(response => (self.publicDomainAccountProperties = response.data))
        .catch(function (error) {
          if (error && error.response) {
            self.error("An error has occurred " + error.response);
          }
        });
    },
    getFaultReportTitle() {
      if (this.settings && this.settings.faultReportTitle) {
        return this.settings.faultReportTitle;
      } else {
        return "Störungsmeldung";
      }
    },
    initTibs(allTibs) {
      let self = this;
      this.tibs = allTibs;
      for (var ii = 0; ii < allTibs.length; ++ii) {
        var tib = allTibs[ii];
        console.info(
          ii +
          "/" +
          allTibs.length +
          ") " +
          tib.path +
          "/" +
          tib.name +
          " " +
          tib.id
        );
      }
      this.readSettings();
      this.readProperties();
      this.readTemplates();
      this.createAddressesFromTibModels();
      if (this.currentTibTag.length > 10) {
        var addressesFiltered = this.addresses.filter(
          a =>
            a.servicekleber.filter(w => w.tib.tag === this.currentTibTag)
              .length == 1
        );
        if (addressesFiltered.length == 1) {
          var skFiltered = addressesFiltered[0].servicekleber.filter(
            w => w.tib.tag === this.currentTibTag
          );

          if (skFiltered.length == 1) {
            this.showServicekleber(skFiltered[0]);
          }
        }
        if (this.currentServicekleber) {
          if (getCookie("tibsession") !== null) {
            this.currentPage = displayPage.TIME_TRACKING;
          }
        } else {
          var filteredTibs = allTibs.filter(
            tib => tib.tag === this.currentTibTag
          );
          if (filteredTibs.length == 1) {
            filteredTibs[0].path = BASE_PATH + "/1/1";
            emptyServicekleber.data.id = 1;
            filteredTibs[0].data = JSON.stringify(emptyServicekleber.data);
            emptyServicekleber.data.id = null;

            axios
              .post(TT_URL + "/api/rest/tibtix/updateTib", filteredTibs[0])
              // eslint-disable-next-line
              .then(response => {
                console.info("saved");
                this.listAllTibs();
              })
              .catch(function (error) {
                self.error(error);
              });
          }
        }
      }
    },
    readSettings() {
      console.info("readSettings");
      for (let i = 0; i < this.tibs.length; i++) {
        let tib = this.tibs[i];
        if (tib.type === "settings") {
          this.settingsTib = tib;
          this.tibs.splice(i, 1);
          break;
        }
      }

      if (this.settingsTib) {
        console.info("parse settings");
        try {
          this.settings = JSON.parse(this.settingsTib.data);
          console.info("parse done.");
        } catch (e) {
          console.error("cannot parse settings\n" + e);
        }
      }

      if (this.settings == null) {
        console.info("no settings");
      }
    },
    readTemplates() {
      console.info("readTemplates");
      this.templateTibs = [];
      for (let i = 0; i < this.tibs.length; i++) {
        let tib = this.tibs[i];
        if (tib.type === "template") {
          this.templateTibs.push(tib);
          this.tibs.splice(i, 1);
        }
      }
    },
    readProperties() {
      console.info("readProperties");
      for (let i = 0; i < this.tibs.length; i++) {
        let tib = this.tibs[i];
        if (tib.type === "properties") {
          this.propertiesTib = tib;
          this.tibs.splice(i, 1);
          break;
        }
      }

      if (this.propertiesTib) {
        console.info("parse properties");
        try {
          this.properties = JSON.parse(this.propertiesTib.data);
          console.info("parse done.");
        } catch (e) {
          console.error("cannot parse properties\n" + e);
        }
      }
    },
    createAddressFromTibModel(tibModel) {
      return {
        tib: tibModel,
        data: JSON.parse(tibModel.data),
        servicekleber: [],
        nextServicekleberId: 1,
        tibs: []
      };
    },
    translateTibModel(
      addressMap,
      servicekleberMap,
      servicekleberArray,
      tibArray,
      tibModel
    ) {
      console.info(
        "translateTibModel " +
        tibModel.path +
        "/" +
        tibModel.name +
        " " +
        tibModel.tag
      );
      if (tibModel.tibType === "_object") {
        if (
          tibModel.type === "address" &&
          tibModel.path.startsWith(BASE_PATH)
        ) {
          var newAddress = this.createAddressFromTibModel(tibModel);
          if (addressMap[tibModel.path]) {
            console.error("more than one address at " + tibModel.path);
          }
          addressMap[tibModel.path] = newAddress;
          this.addresses.push(newAddress);
          if (newAddress.data.id >= this.nextAddressId) {
            this.nextAddressId = newAddress.data.id + 1;
          }
        } else if (tibModel.type === "servicekleber") {
          let wk = createServicekleberFromTibModel(tibModel);
          servicekleberArray.push(wk);
          if (servicekleberMap[tibModel.path]) {
            console.error("more than one servicekleber at " + tibModel.path);
          }
          servicekleberMap[tibModel.path] = wk;
        } else {
          tibArray.push(tibModel);
        }
      } else {
        tibArray.push(tibModel);
      }
    },
    attachServicekleberToAddress(addressMap, wk) {
      console.info("attachServicekleberToAddress");
      var path = wk.tib.path.split("/");
      var addressId = BASE_PATH + "/" + path[2];
      var address = addressMap[addressId];

      if (address) {
        address.servicekleber.push(wk);
        wk.address = address;

        if (wk.data.id >= address.nextServicekleberId) {
          address.nextServicekleberId = wk.data.id + 1;
        }
      } else {
        console.error("No such address: " + addressId);
      }
    },
    attachTibToAddressOrServicekleber(addressMap, servicekleberMap, tib) {
      var address = addressMap[tib.path];
      var wk = servicekleberMap[tib.path];

      console.info("attachTibToAddressOrServicekleber");

      if (address) {
        address.tibs.push(tib);
        console.info("address");
      }
      if (wk) {
        wk.tibs.push(tib);
        console.info("servicekleber");
      }
    },
    createAddressesFromTibModels() {
      console.info("createAddressesFromTibModels");
      this.addresses.splice(0, this.addresses.length);
      var addressMap = {};
      var servicekleberMap = {};
      var servicekleberArray = [];
      var tibArray = [];

      this.tibs.forEach(tibModel =>
        this.translateTibModel(
          addressMap,
          servicekleberMap,
          servicekleberArray,
          tibArray,
          tibModel
        )
      );
      this.addresses.sort((a, b) =>
        a.data.id > b.data.id ? 1 : b.data.id > a.data.id ? -1 : 0
      );
      this.addresses.forEach(address => {
        if (address.data.popupMessage == "undefined") {
          address.data.popupMessage = "";
        }
      });
      servicekleberArray.sort((a, b) =>
        a.data.id > b.data.id ? 1 : b.data.id > a.data.id ? -1 : 0
      );
      console.info("addresses.lenght    " + this.addresses.length);
      console.info("servicekleberArray.lenght    " + servicekleberArray.length);
      servicekleberArray.forEach(wk =>
        this.attachServicekleberToAddress(addressMap, wk)
      );
      console.info("tibArray.lenght    " + tibArray.length);
      tibArray.forEach(tib =>
        this.attachTibToAddressOrServicekleber(
          addressMap,
          servicekleberMap,
          tib
        )
      );
      this.allServicekleber = servicekleberArray;
    },
    createServicekleber(address, extRef) {
      let self = this;
      emptyServicekleber.data.extRef = extRef ? extRef : null;
      emptyServicekleber.data.id = 1;

      if (address) {
        emptyServicekleber.data.id = address.nextServicekleberId;
        address.nextServicekleberId = address.nextServicekleberId + 1;
        this.currentDir = address.tib.path;
      }

      if (!this.currentDir.startsWith(BASE_PATH)) {
        this.currentDir = BASE_PATH + "/1";
      }

      console.info("createServicekleber: " + this.currentDir);

      axios
        .post(TT_URL + "/api/rest/tibtix/createTib", {
          name: extRef
            ? extRef
            : "Servicekleber - " + emptyServicekleber.data.id,
          path: this.currentDir + "/" + emptyServicekleber.data.id,
          tag: this.newTibTag,
          tibType: "_object",
          type: "servicekleber",
          data: JSON.stringify(emptyServicekleber.data),
          contentAccess: "Open"
        })
        .then(response => {
          var newServicekleber = createServicekleberFromTibModel(
            response.data
          );
          newServicekleber.doEdit = true;
          newServicekleber.address = address;
          address.servicekleber.push(newServicekleber);
          this.allServicekleber.push(newServicekleber);
          this.newTibTag = null;
          this.showAddress(address);
          this.showServicekleber(newServicekleber);
        })
        // eslint-disable-next-line
        .catch(function (error) {
          self.error("An error has occurred.");
        });
    },
    createAddress(addressNameOfNewServicekleber, extRef) {
      let self = this;
      emptyAddress.data.id = this.nextAddressId;
      this.nextAddressId = this.nextAddressId + 1;
      this.currentDir = BASE_PATH;

      let newAddressName = addressNameOfNewServicekleber
        ? addressNameOfNewServicekleber
        : "Adresse - " + emptyAddress.data.id;

      axios
        .post(TT_URL + "/api/rest/tibtix/createTib", {
          name: newAddressName,
          path: this.currentDir + "/" + emptyAddress.data.id,
          tibType: "_object",
          type: "address",
          data: JSON.stringify(emptyAddress.data),
          contentAccess: "Open"
        })
        .then(response => {
          let newAddress = this.createAddressFromTibModel(response.data);
          newAddress.doEdit = true;
          this.addresses.push(newAddress);
          this.currentAddress = newAddress;
          if (extRef) {
            this.createServicekleber(this.currentAddress, extRef);
          }
        })
        // eslint-disable-next-line
        .catch(function (error) {
          self.error("An error has occurred.");
        });
    },
    showTib(tibtag) {
      this.currentTibTag = tibtag;
      this.readTib();
      this.listDir();
    },
    showAddress(address) {
      console.info("#app.showAddress:" + address.tib.path);
      this.currentAddress = address;
      this.currentServicekleber = null;
      this.currentDir = address.tib.path;
      this.show(displayPage.ADDRESS);
    },
    showAddressList() {
      this.currentDir = BASE_PATH;
      this.currentAddress = null;
      this.updateData();
      this.show(displayPage.ADDRESS_LIST);
    },
    showServicekleber(servicekleber) {
      console.info("#app.showServicekleber:" + servicekleber.tib.path);
      this.currentTibTag = servicekleber.tib.tag;
      this.currentDir = servicekleber.tib.path;
      this.currentAddress = servicekleber.address;
      this.currentServicekleber = servicekleber;
      if (!this.isLoggedIn && this.currentServicekleber && this.currentServicekleber.tib.attributesMap.payAccount) {
        this.showOnlyPayButton = true;
      }
      window.document.title = "Servicekleber " + (this.currentServicekleber.tib.name == null ? "" : this.currentServicekleber.tib.name);
      setCookie("lastdomainname", servicekleber.tib.authorDomainName, 365);
      setCookie(
        "lastaccountname",
        servicekleber.tib.authorDomainAccountName,
        365
      );
      console.info(
        "Set cookie: " +
        getCookie("lastaccountname") +
        "##" +
        getCookie("lastdomainname")
      );
    },
    showDomainJournal() {
      let self = this;
      axios
        .get(TT_URL + "/api/rest/tibtix/searchTibJournalEntries/null")
        .then(response => {
          self.domainJournalEntries = response.data;
          for (let domainJournalEntry of self.domainJournalEntries) {
            self.attachTibToJournalEntry(domainJournalEntry);
          }
          console.info(
            "domainJournalEntries = " + self.domainJournalEntries.length
          );
        })
        .catch(function (error) {
          console.error("cannot load journal " + error);
          self.error("An error has occurred.");
        });

      this.show(displayPage.DOMAIN_JOURNAL);
    },
    attachTibToJournalEntry(domainJournalEntry) {
      if (this.tibs) {
        for (let tib of this.tibs) {
          console.info(tib.tag + " --- " + domainJournalEntry.tibTag);
          if (tib.tag === domainJournalEntry.tibTag) {
            console.info(" FOUND!!! ");
            domainJournalEntry.tib = tib;
            break;
          }
        }
      }
    },
    saveJournalEntry(journalEntry) {
      if (journalEntry.timestamp) {
        console.info(
          "save journal entry " +
          journalEntry.timestamp +
          " " +
          journalEntry.text
        );

        let self = this;
        let localJournalEntry = journalEntry;
        axios
          .post(TT_URL + "/api/rest/tibtix/updateTibJournalEntry", journalEntry)
          .then(response => {
            console.info("journal entry saved");
            var savedTib = response.data;
            if (localJournalEntry.tib != null) {
              localJournalEntry.tib.journal = savedTib.journal;
            } else if (
              self.currentServicekleber &&
              self.currentServicekleber.tib
            ) {
              self.currentServicekleber.tib.journal = savedTib.journal;
            }
          })
          .catch(function (error) {
            console.error("Cannot save journal entry " + error);
            self.error("An error has occurred.");
          });
      } else {
        this.addJournalEntry(journalEntry);
      }
    },
    addJournalEntry(tibJournalEntryModel) {
      console.info(
        "add journal entry " +
        tibJournalEntryModel.timestamp +
        " " +
        tibJournalEntryModel.text
      );
      let self = this;
      if (!tibJournalEntryModel.text) {
        this.error("Bitte Nachricht erfassen!");
      } else {
        axios
          .post(
            TT_URL +
            "/api/client/addJournalEntry/" +
            this.currentServicekleber.tib.tag,
            tibJournalEntryModel
          )
          .then(response => {
            var savedTib = response.data;
            self.currentServicekleber.tib.journal = savedTib.journal;
            self.show(displayPage.HOME);
          })
          .catch(function (error) {
            console.error("not saved " + error);
            self.error("An error has occurred.");
          });
      }
    },
    updateLoginStatus() {
      console.info("getLoginStatus()");
      let self = this;
      axios
        .get(TT_URL + "/api/tibtix.com/login")
        .then(response => {
          self.loggedIn = response.data.loggedIn && !response.data.connectionId;
        })
        // eslint-disable-next-line
        .catch(function (error) {
          self.setLoggedIn(false);
        });
      return this.loggedIn;
    },
    tibTagChanged() {
      this.newTibTag = null;
      this.$forceUpdate();
    },
    isSameTib(tibtag) {
      console.info(tibtag === this.currentTibTag ? true : false);
      return tibtag === this.currentTibTag ? true : false;
    },
    observeBrowserUrl() {
      let self = this;
      window.onpopstate = function (event) {
        console.log(
          "location: " +
          document.location +
          ", state: " +
          JSON.stringify(event.state)
        );
        var display = new URL(location.href).searchParams.get("currentPage");
        self.show(display ? display : displayPage.HOME);
      };
      var display = new URL(location.href).searchParams.get("currentPage");

      if (display) {
        self.show(display);
      }
    },
    code(v) {
      console.info("CODE=" + v);
      if (v) {
        if (v === "000") {
          console.info("activate cashIn");
          this.cashInActive = true;
          return;
        }
        // for (
        //   let index = 0;
        //   index < this.settings.journalTemplates.length;
        //   ++index
        // ) {
        //   var template = this.settings.journalTemplates[index];
        //
        //   if (template.code === v) {
        //     this.show(displayPage.EDIT_JOURNAL_ENTRY);
        //     console.info("Template=" + template.text);
        //     this.journalEntry.text = template.code + ": " + template.text;
        //     return;
        //   }
        // }

        if (v.length == 6) {
          //try to pay with code
          this.payWithCode(v);
        }
      } else {
        this.show(displayPage.HOME);
      }
    },
    payWithCode(code) {
      let self = this;

      axios
        .post(TT_URL + "/api/rest/tibtix/pay/payVendingMachineWithCode", {
          "tibTag": this.currentServicekleber.tib.tag,
          "amount": 1000,
          "timestamp": Date.now(),
          "code": code
        })
        .then(function (response) {
          if (response.data.errorCode) {
            self.error("Zahlung nicht möglich! " + response.data.errorText);
          } else {
            console.log("SUCCESS!!");
            self.infoMessage = "# Der Code ist korrekt!\n\nSie können nun ein Produkt am Automaten beziehen!";
            self.show(displayPage.HOME);
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
          self.error("Der Code wurde nicht akzeptiert! Zahlung nicht möglich!");
        });
    },
    isVendingMachineEnabled() {
      let self = this;

      axios
        .get(TT_URL + "/api/rest/tibtix/pay/isVendingMachineEnabled/" + self.currentTibTag)
        .then(function (response) {
          if (!response.data) {
            self.infoMessage = "# Ausser Betrieb!\n\nSie können zur Zeit keine Produkte an diesem Automaten beziehen!";
            self.show(displayPage.HOME);
          }
        })
        .catch(function () {
          self.error("System nicht verfügbar!");
        });
    },
    cancelInfoMessage() {
      this.infoMessage=null;
    },
    show(display) {
      console.info("show " + display);
      this.lastPage = this.currentPage;
      this.currentPage = display;
      if (display === displayPage.ADDRESS_LIST) {
        this.navbar = "home";
        this.updateLoginStatus();

        if (!this.loggedIn) {
          this.show(displayPage.HOME);
        }
      } else if (
        display === displayPage.DOMAIN_JOURNAL ||
        display === displayPage.TIB_JOURNAL
      ) {
        this.navbar = "journal";
      } else {
        this.navbar = display;
      }
      if (display === displayPage.NEW_QR_CODE || display === displayPage.LOGIN) {
        console.info("addresses: " + this.addresses.length);
      } else {
        //location.href = new URL(location.href).searchParams.set("currentPage", display).toString();
        history.pushState(
          {page: 1},
          display,
          "?tag=" + this.currentTibTag + "&currentPage=" + display
        );
      }
      // if (
      //   display === displayPage.HOME &&
      //   !this.loggedIn &&
      //   !this.currentServicekleber
      // ) {
      //   this.show(displayPage.LOGIN);
      // }
      if (
        display === displayPage.TIME_TRACKING &&
        this.currentServicekleber &&
        this.loggedIn
      ) {
        this.logout();
      }
    },
    setLoggedIn(on) {
      console.info("setLoggedIn:" + on);
      this.loggedIn = on;
      if (this.loggedIn) {
        this.updateData();
        if (this.currentAddress) {
          this.show(displayPage.ADDRESS);
        } else {
          this.show(displayPage.ADDRESS_LIST);
        }
      } else {
        this.show(displayPage.HOME);
      }
    },
    error(msg) {
      this.errorMessage = msg;
      this.show(displayPage.ERROR);
    },
    showMessage(on) {
      this.messageVisible = on;
    },
    updateTranslations() {
      var newTranslation = {};
      for (let prop in translation) {
        newTranslation[prop] = translation[prop][lang];
      }
      this.tp = newTranslation;
    },
    back() {
      this.show(this.lastPage);
    },
    logout() {
      console.info("logout()");
      let self = this;

      axios
        .get(TT_URL + "/logout", {crossDomain: true})
        // eslint-disable-next-line
        .then(function (response) {
          self.setLoggedIn(false);
        })
        .catch(function (error) {
          self.error("An error has occurred. " + error);
        });
    },
    // eslint-disable-next-line
    uploadFile(event) {
      let formData = new FormData();

      formData.append("file", this.file);
      formData.append("path", this.currentDir);
      let self = this;
      self.fileName = "hochladen...";

      axios
        .post(TT_URL + "/api/upload/file", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function (response) {
          console.log("SUCCESS!!");
          self.fileName = "";

          if (self.currentAddress) {
            if (self.currentServicekleber) {
              self.currentServicekleber.tibs.push(response.data);
            } else {
              self.currentAddress.tibs.push(response.data);
            }
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
          self.error("Upload failed!");
          self.fileName = "[error]";
        });
    },
    handleFileUpload() {
      console.info("handleFileUpload " + this.$refs.fileInput.files[0]);
      this.file = this.$refs.fileInput.files[0];
      this.fileName = this.$refs.fileInput.files[0].name;
    },
    tibtixAdmin() {
      this.updateDomainAccountProperties();
      window.location.href =
        "/tt/view/" +
        this.publicDomainAccountProperties.hashhashDomain +
        "/" +
        this.publicDomainAccountProperties.accountName +
        "/tibs";
    },
    filter(servicekleber) {
      if (isEmptyString(this.searchText)) {
        return true;
      }

      let fulltext =
        servicekleber.tib.name +
        " " +
        servicekleber.data.extRef +
        " " +
        servicekleber.address.tib.name;

      return fulltext.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0;
    },
    onScan(result) {
      console.info("onScan: " + result);
      var index = result.lastIndexOf("/");
      if (index > 0) {
        var scannedTag = result.substring(index + 1);
        for (let servicekleber of this.allServicekleber) {
          if (servicekleber.tib.tag == scannedTag) {
            this.showServicekleber(servicekleber);
            if (getCookie("tibsession") == null) {
              this.show(displayPage.HOME);
            } else {
              this.show(displayPage.TIME_TRACKING);
            }

            return;
          }
        }
        window.location.href = result;
      }
      this.show(displayPage.ADDRESS_LIST);
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
    pay() {
      console.info("pay: " + this.currentServicekleber.tib.attributesMap.payAccount + " " + this.currentServicekleber.tib.attributesMap.regId);
      axios
        .get(TT_URL + "/api/currentTimeMillis")
        .then(response => document.location.href = 'pay.html?domain=' +
          this.publicDomainAccountProperties.hashhashDomain +
          "&account=" + this.currentServicekleber.tib.attributesMap.payAccount +
          "&caption=" + encodeURI(this.getVendingMachineCaption()) +
          "&tibTag=" + this.currentServicekleber.tib.tag +
          "&timestamp=" + response.data)
        .catch(function () {
          console.error("Cannot access server");
        });
    },
    getVendingMachineCaption() {
      return this.currentServicekleber.tib.name + " " + this.currentServicekleber.data.extRef + " " + this.currentServicekleber.address.tib.name;
    }
  },
  computed: {
    isMessageVisible: function () {
      var result =
        !this.loggedIn &&
        this.messageVisible &&
        this.currentPage == displayPage.HOME &&
        this.currentServicekleber != null &&
        (this.currentServicekleber.data.popupMessage.length > 0 ||
          (this.currentServicekleber.address.data.popupMessage &&
            this.currentServicekleber.address.data.popupMessage.length > 0));
      console.info("isMessageVisible = " + result);
      return result;
    }
  }
};
</script>

<style></style>
